import {useState, useRef, useEffect} from "preact/hooks"
import { getJaaSToken } from "../41082/utils"

import {useInterval, useJitsi} from "../utils/hooks"
import {get, post, put} from "../utils/http"


const Others = ({participants}) => {
	const [othersCard, setOthersCard] = useState(false)

	return <div
		className="participant others"
		onclick={event => {
			event.stopPropagation()
			setOthersCard(!othersCard)
		}}
	>
		<h1 className="others_text">Others</h1>
		{othersCard ? <><OthersCard participants={participants} /><div class="modal_underlay" /></> : null}
	</div>
}

const OthersCard = ({participants}) => {
	const [othersCard, setOthersCard] = useState(false)

	return <div className="otherscard">
		{participants.map(({name}, i) =>
			<p key={i} className="otherscard_name">{name}</p>,
		)}
		<button className="otherscard_close" onclick={() => setOthersCard(othersCard)}>Close</button>
	</div>
}

const InfoCard = ({participant}) => {
	const [isActive, setIsActive] = useState(false)

	return <div className="infocard">
		<p className="infocard_close-icon" onclick={() => setIsActive(isActive)}>X</p>
		<div className="info-container">
			<img className="infocard_image" src={participant.headshot} />
			<div className="info-text-container">
				<p className="info_company">Company: {participant.company}</p>
				<p className="info_name">Name: {participant.name}</p>
			</div>
		</div>

		<div className="infocard_buttons">
			<button className="infocard_message" onclick={() => window.openDM(participant.userRegID)}>Message me</button>
		</div>
	</div>
}

const Participant = participant => {
	const [isActive, setIsActive] = useState(false)
	const toggle = event => {
		setIsActive(!isActive)
		event.stopPropagation()
	}

	return <div className={`participant participant${participant.id + 1}`} onclick={toggle}>
		<img src={participant.headshot} title="click me for participant info" />
		{isActive ? <><InfoCard participant={participant} /><div class="modal_underlay" /></> : null}
	</div>
}

const Table = ({id, participants = [], joinCall, seatsPerTable}) => {
	const overflowed = participants.length >= seatsPerTable
	return <div id={`table${id + 1}`} class="hotspot" onclick={() => joinCall(id)}>
		{participants
			.slice(0, overflowed ? seatsPerTable - 1 : seatsPerTable)
			.map(({headshot, name, company, id}, i) => <Participant
				id={i}
				headshot={headshot}
				name={name}
				company={company}
				userRegID={id}
			/>)
		}
		{overflowed ? <Others participants={participants} name={name} /> : null}
	</div>
}


const Search = ({tables}) => {
	const [searchTerm, setSearchTerm] = useState("")
	const names = tables
		.reduce((acc, table) => [...acc, ...table], [])
		.map(participant => participant.name)
		.sort()
	const matchingNames = searchTerm.length
		? names.filter(name => name.includes(searchTerm))
		: []
	const findTable = name => tables.findIndex(table => table.some(participant => participant.name == name))

	const handleChange = e => {
		setSearchTerm(e.target.value)
	}
	return <div class="userSearch">
		<div class="search-container">
			<label class="search_label">Search for participants</label>
			<input class="search_input" placeholder="First Name" value={searchTerm} onInput={handleChange} />
		</div>

		{
			searchTerm.length && matchingNames.length
				? <ol class="searchResults">
					{matchingNames.map(name => <li class="results">{name} @ Table {findTable(name) + 1}</li>)}
				</ol>
				: null
		}
	</div>
}

export const RoundTables = ({numTables = 3, seatsPerTable = 6, dataSource = "https://crs1.tkevents.io:3001"}) => {
	const [dataLayer] = window.dataLayer
	const {"First & Last Name": name, "Headshot": headshot, "Company": company, "Registrant ID": userRegID, "Event ID": eventID} = dataLayer
	const email = dataLayer["Email Address"]
	const displayName = dataLayer["First & Last Name"]
	const avatarURL = dataLayer.Headshot
	const {current: jitsiWindowID} = useRef(Math.floor(Math.random() * 1e5))
	const [callNumber, setCallNumber] = useState(null)
	const [jwt, updatejwt] = useState({})
	useEffect(() => {
		const interval = window.setInterval(
			async () => {updatejwt(await getJaaSToken())},
			7200000
		)

		return () => window.clearInterval(interval)
	}, [])
	const options = {
		parentNode: document.getElementById(`${jitsiWindowID}`),
		roomName: callNumber === null ? null : `vpaas-magic-cookie-4259c4d2028945bdb8d111f1b2f27c68/ISF Roundtable ${jitsiWindowID}`,
	}
	const userInfo = {
		avatarURL,
		displayName,
		email,
	}
	useJitsi(options, userInfo, "8x8.vc")

	const inCall = callNumber !== null
	const [tables, setTables] = useState(new Array(numTables).fill([]))

	const sendHeartbeat = async tableID => {
		const initials = name.split(" ").reduce((acc, val) => `${acc}${val[0]}`, "")

		try {
			await put(
				`${dataSource}/${eventID}/${userRegID}`,
				{company, eventID, headshot, initials, name, tableID}
			)
		} catch (e) {
			if (e.status == 404) {
				await post(
					`${dataSource}/${eventID}`,
					{company, eventID, headshot, id: userRegID, initials, name, tableID}
				)
			} else { throw e }
		}
	}

	useInterval(() => {
		if (inCall) { sendHeartbeat(callNumber) }
	}, 1000)

	useInterval(async () => {
		const newParticipants = await get(`${dataSource}/${eventID}`, {maxAge: 3000})
		const newTables = new Array(numTables).fill([])
		newParticipants.sort((a, b) =>
			a.name > b.name ? 1 : -1
		).forEach(({tableID, ...rest}) => {
			newTables[tableID].push(rest)
		})
		setTables(newTables)
	}, 1000)

	const joinCall = number => {
		setCallNumber(number)
		sendHeartbeat(number)
	}

	return <>
		{new Array(numTables).map(
			i => <Table joinCall={joinCall} id={i} participants={tables[i]} seatsPerTable={seatsPerTable}/>,
		)}
		<div id={jitsiWindowID} style={{height: "103.6%", left: "27%", position: "absolute", top: "1.8%", transform: "scale(0.5)", transformOrigin: "top left", width: "92.2%"}} />
		<Search tables={tables} />
	</>
}
